<template lang="html">
    <div class="meeting-room">
        <UiNotification/>
        <div class="video-call">
            <div class="remote-user-video">
                <span class="camera-preview-timer" v-if="this.timerStarted">
                        <i class="fas fa-clock"></i>
                        {{this.minutes}}:{{this.seconds}}
                </span>
                <span class="camera-preview-text" v-else>
                      <i class="fas fa-info-circle"/>
                      Sedinta va incepe in curand
                </span>
                <div class="camera-preview" id="localTrack"></div>
                <div class="fullscreen-button">
                    <i class="fas fa-expand top-control-icon" @click="toggleFullscreen"></i>
                </div>
                <div class="rotate-button" id="rotateButtonLandscape">
                    <i class="fas fa-undo top-control-icon"></i>
                </div>
                <div class="flash-new-message" :class="{'flash': this.flashMessageAnimation}" id="flashMessage">
                    <span>{{flashMessageText}}</span>
                </div>
                <div id="remoteTrack"></div>
            </div>

            <CallControls v-if="this.twilioRoom" @close="endCall" @micStatus="toggleMic" @videoStatus="toggleVideo" @retryDevices="openJoinWithProblems" :hasMic="this.localUser.microphone !== null" :hasVideo="this.localUser.video !== null"/>
        </div>
          <Chat :localUser="this.localUser" ref="chat" @userJoined="updateLocalUser" @newMessage="flashMessage($event)"/>
          <!-- <MeetingEndModal v-if="feedbackModal.active" @close="leaveMeeting"/> -->
          <MeetingEndModal v-if="feedbackModal.active" @close="leaveMeeting"/>


          <JoinWithProblemsModal v-if="this.showJoinWithProblems" @close="closeJoinWithProblems"/>
          <SpecialistNotConnectedModal v-if="this.showSpecialistNotConnected" @close="leaveMeeting"/>
          <audio style="display: none;" preload="none" id="meeting-joinleave-audio">
            <source src="@/assets/audio/userjoinorleave.mp3" type="audio/mpeg">
          </audio>
          <audio style="display: none;" preload="none" id="meeting-timeleft-audio">
            <source src="@/assets/audio/timeleft.mp3" type="audio/mpeg">
          </audio>


        <PaymentModal v-if="$store.state.payments.modal.active"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import router from '@/router.js'
import * as moment from 'moment'

import UiNotification from '@/components/ui/Notification';
import Chat from './Chat.vue'
import CallControls from './CallControls.vue'
import CameraPreview from './CameraPreview.vue'
import JoinWithProblemsModal from './JoinWithProblemsModal';
import MeetingEndModal from './MeetingEndModal'
import SpecialistNotConnectedModal from './SpecialistNotConnectedModal'

import Twilio, { connect, createLocalTracks, createLocalVideoTrack } from 'twilio-video'
import TransactionCardVue from '../specialist/TransactionsPage/components/TransactionCard.vue'

import PaymentModal from '@/layouts/Dashboard/components/PaymentModal'

export default {
    components: {
        Chat,
        CallControls,
        CameraPreview,
        UiNotification,
        JoinWithProblemsModal,
        MeetingEndModal,
        SpecialistNotConnectedModal,
        PaymentModal
    },
    data() {
        return {
            minutes: 0,
            seconds: 0,
            timerStarted: null,
            timerInterval: null,
            flashMessageAnimation: false,
            flashMessageText: "",
            joinWithVideo: true,
            localUser: {},
            localVideoTrack: '',
            localAudioTrack: '',
            remoteTrack: '',
            twilioRoom: '',
            showJoinWithProblems: false,
            showSpecialistNotConnected: false,
        };
    },
    created() {
        this.joinMeetingRoom(this.$router.currentRoute.query.token);
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            feedbackModal: 'meeting/feedbackModal',
            meeting: 'meeting/meeting',
            twilioToken: 'meeting/twilioToken',
            roomHash: 'meeting/roomHash',
        }),
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 1200) {
                return true
            }
            return false
        },
    },
    watch: {
        twilioToken: { //**ALL STARTS FROM HERE -> WHEN THE USER IS APPENDED IN STATE
            handler(newVal) {
                if (newVal != null && this.twilioRoom == '') {
                    // check if userId from state is available
                    this.joinVideoRoom();
                }
            },
            immediate: true // make this watch function is called when component created
        },
        'this.$store.state.drawer': {
            handler(newVal) {
                if (newVal != null && this.twilioRoom) {
                    this.setTimer();
                }
            },
            immediate: true // make this watch function is called when component created
        }
    },
    methods: {
        ...mapActions({
            joinMeetingRoom: 'meeting/join',
            fetchWidget: 'layout/widget' // Action that fetch current user appointment widget
        }),
        openSpecialistNotConnected(){
          this.showSpecialistNotConnected = true;
        },
        closeJoinWithProblems(){
          this.showJoinWithProblems = false;
        },
        openJoinWithProblems(){
          this.showJoinWithProblems = true;
        },
        notifyWarningMinutes(minutes){
          var message = 'Intalnirea se apropie de sfarsit! Mai aveti '+minutes+ ' minute ramase.';
          if(minutes == 1){
            message = 'Intalnirea se apropie de sfarsit! Camera se va inchide intr-un minut.';
            
            let audio = document.getElementById('meeting-timeleft-audio');
            audio.play();
          }


          //Notify
          this.$store.state.notification.notification.icon = null;
          this.$store.state.notification.notification.title = null;
          setTimeout(() => {
            this.$store.state.notification.notification.icon = 'info';
            this.$store.state.notification.notification.title = message;
          }, 200)


        },
        flashMessage(message){
          let meetingRoomElement = document.getElementsByClassName('meeting-room')[0];
          let mobileRotateButton = document.getElementById('rotateButtonLandscape');

          if(meetingRoomElement.classList.contains('fullscreen') || window.getComputedStyle(mobileRotateButton).display === "block") {

            let reflashed = false;
            if(this.flashMessageAnimation == true)
              reflashed = true;

            this.flashMessageAnimation = true;
            if(typeof message.body === 'object')
                if((message.body.type).startsWith('image'))
                  this.flashMessageText = '[IMAGINE RECEPȚIONATĂ]';
                else if((message.body.type).startsWith('video'))
                  this.flashMessageText = '[VIDEOCLIP RECEPȚIONAT]';
                else
                  this.flashMessageText = '[DOCUMENT RECEPȚIONAT]';
            else
            if(message.body.length > 20)
                  this.flashMessageText = message.body.substr(0,19) + '...';
              else
                  this.flashMessageText = message.body;

            let VueThis = this;
            setTimeout(function () {
              if(reflashed == false)
                VueThis.flashMessageAnimation = false;
              reflashed = false;
            }, 5000);
          }
        },
        setTimer(){
          //Daca specialistul nu a intrat inca in sedinta => Afisare "Sedinta va incepe in curand" DONE
          //Daca start_timestamp + meetingBreakDuration > now && specialist not joined => Close room - Specialist not joined
          //Daca specialist joined => Display time left
          //How to calc time left: (specialist_joined_at + meetingDuration) - now
          let appointmentServicesCount = this.meeting.appointment.services_count;
          let standardServiceDuration = 30; // MINUTES | should be sent as meta
          let standardBreakDuration = 5; // MINUTES | should be sent as meta
          let meetingDuration = appointmentServicesCount * standardServiceDuration;
          let meetingBreakDuration = appointmentServicesCount * standardBreakDuration;
          let now = new Date();

          if(this.meeting.specialist_joined_at != null) this.timerStarted = true;
          else this.timerStarted = false;

          if(this.timerStarted){
            let endTime = new Date(this.meeting.specialist_joined_at);
            let meetingDurationMillis = meetingDuration * 60 * 1000;
            endTime = endTime.getTime() + meetingDurationMillis;

            let timeLeft = endTime - now.getTime();

            this.hours = new Date(timeLeft).getUTCHours();
            this.minutes = new Date(timeLeft).getUTCMinutes();

            let displaySeconds = new Date(timeLeft).getUTCSeconds();
            if(displaySeconds < 10)
              this.seconds = '0' + displaySeconds.toString();
            else
            this.seconds = displaySeconds;

            if(this.hours > 0) {
              this.minutes = this.minutes + this.hours*60;
              this.hours = 0;
            }

            //Notificari 5min, 3 min, 30sec
            if(((this.minutes == 5 || this.minutes == 3 || this.minutes == 1) && this.seconds == '01') && this.hours == 0)
              this.notifyWarningMinutes(this.minutes);

            //Daca timpul s-a terminat.
            if(this.hours == 0 && this.minutes == 0 && this.seconds == '01') {

              clearInterval(this.timerInterval);
              if(localStorage.getItem('role') != 'specialist') this.openMeetingEndModal();
              else this.leaveMeeting();

              console.log('NO TIME LEFT !!');
            }

          }
          else{
            if(moment(this.meeting.appointment.start_timestamp).add(meetingBreakDuration ,'minutes').valueOf() - now.getTime() <= 0){
              console.log('Specialistul nu s-a conectat! | ' + (moment(this.meeting.appointment.start_timestamp).add(meetingBreakDuration ,'minutes').valueOf() - now.getTime()) );
              if(localStorage.getItem('role') != 'specialist'){
                //this.openSpecialistNotConnected();
                //this.endCall();
              }
              else{
//                this.leaveMeeting();
              }
              clearInterval(this.timerInterval);
            }
            //console.log('SPECIALIST LATE / NOT JOINED');
          }

          return 0;
        },
        setTimerOld() {
            if(this.meeting != null) {

                let appointmentServicesCount = this.meeting.appointment.services_count;
                let standardServiceDuration = 30;
                let standardBreakDuration = 5;

                let meetingDuration = appointmentServicesCount*standardServiceDuration;
                let meetingBreakDuration = appointmentServicesCount * standardBreakDuration;

                let now = new Date();

                if(moment(this.meeting.appointment.end_timestamp).valueOf() - now.getTime() - meetingBreakDuration*1000){
                  console.log('Specialistul nu s-a conectat');
                  if(localStorage.getItem('role') != 'specialist')
                      this.openSpecialistNotConnected();
                  else
                      this.leaveMeeting();

                  clearInterval(this.timerInterval);
                }

                if(this.meeting.specialist_joined_at != null){
                  this.timerStarted = true;
                  var endTime = new Date(this.meeting.appointment.end_timestamp);

                  var passedTime = endTime.getTime() - now.getTime();

                  this.hours = new Date(passedTime).getUTCHours();
                  this.minutes = new Date(passedTime).getUTCMinutes();
                  var displaySeconds = new Date(passedTime).getUTCSeconds();
                  if(displaySeconds < 10)
                      this.seconds = '0' + displaySeconds.toString();
                  else
                      this.seconds = displaySeconds;

                  if(this.hours > 0) {
                      this.minutes = this.minutes + this.hours*60;
                      this.hours = 0;
                  }

                  //Notificari 5min, 3 min, 30sec
                  if((this.minutes == 5 || this.minutes == 3 || this.minutes == 1) && this.seconds == '01')
                    this.notifyWarningMinutes(this.minutes);

                  if(this.minutes >= this.meeting.duration) {
                      this.endCall();
                  }

                  if(this.minutes === 0 && this.seconds === 0) {
                      if(localStorage.getItem('role') != 'specialist')
                          this.openMeetingEndModal();
                      else
                          this.leaveMeeting();

                      clearInterval(this.timerInterval);
                  }
                }
                else{
                  this.timerStarted = false;
                }
            } else clearInterval(this.timerInterval);
        },
        openMeetingEndModal() {
            this.$store.state.meeting.feedbackModal.active = true;
            this.$store.state.layout.widget = {};
        },
        //Meeting room controls
        updateLocalUser(){
          this.localUser.online = true;

          if(this.localAudioTrack)
            if(this.localAudioTrack.isEnabled)
              this.localUser.microphone = true;
            else
              this.localUser.microphone = false;
          else
            this.localUser.microphone = null;

          if(this.localVideoTrack)
            if(this.localVideoTrack.isEnabled)
              this.localUser.video = true;
            else
              this.localUser.video = false;
          else
            this.localUser.video = null;

          let eventData = {
            event: 'status_update',
            localUser: this.localUser,
            roomHash: this.roomHash
          }

          this.$socket.emit('status_update', eventData) //send message to socket server
        },
        endCall() {
          //Disconnect user from twilio room
          if(this.twilioRoom)
            this.twilioRoom.disconnect();

          //If user ends call in the last 5minutes he will be asked to give a feedback
          if(this.minutes < 5 && localStorage.getItem('role') != 'specialist' && this.timerStarted) {
                clearInterval(this.timerInterval);
                this.openMeetingEndModal();
            } else {
                this.leaveMeeting();
            }
        },
        leaveMeeting() {
            this.$store.state.meeting.feedbackModal.active = false;
            // Redirect user to dashboard if is authentifcated of login page if not
            var token = localStorage.getItem('token');
            var role = localStorage.getItem('role');
            if(token && role){
                router.push('/'+role+'/appointments');
                location.reload();
            }
            else{
                router.push('/login');
                location.reload();
            }
        },
        toggleFullscreen() {
            let meetingRoomElement = document.getElementsByClassName('meeting-room')[0];

            if(meetingRoomElement.classList.contains('fullscreen')){
                meetingRoomElement.classList.remove('fullscreen')
                document.exitFullscreen();
            } else {
                meetingRoomElement.classList.add('fullscreen')
                meetingRoomElement.requestFullscreen();
            }
        },
        toggleVideo(status){
          if(status == true && this.localVideoTrack.isEnabled == false)
            this.localVideoTrack.enable();

          if(status == false && this.localVideoTrack.isEnabled == true)
            this.localVideoTrack.disable();

          this.updateLocalUser();
        },
        toggleMic(status){
          if(status == true && this.localAudioTrack.isEnabled == false)
            this.localAudioTrack.enable();

          if(status == false && this.localAudioTrack.isEnabled == true)
            this.localAudioTrack.disable();

          this.updateLocalUser();
        },
        joinVideoRoom() {

          var VueThis = this;
          const apiToken = this.twilioToken;
          let joinWithVideo = this.$router.currentRoute.query.joinVideo;
          let joinWithAudio = this.$router.currentRoute.query.joinAudio;
          joinWithAudio = (joinWithAudio == "false" ? false : true);
          joinWithVideo = (joinWithVideo == "false" ? false : {width: 720})

          if(joinWithAudio == false && joinWithVideo == false){
            this.openJoinWithProblems();
            console.log('Meeting join with problems');
          }

          console.log('Trying to connect to room: ' + this.roomHash);

          Twilio.connect(apiToken, {name: this.roomHash, audio: joinWithAudio, video: joinWithVideo}).then(room => {
            this.twilioRoom = room;
            console.log(`Successfully joined a Room: ${room}`);

            //Display time remaining
            this.timerInterval = setInterval(() => {
              this.setTimer();
            }, 1000);

            //FOR REMOTE PARTICIPANTS THAT ARE ALREADY IN ROOM
            room.participants.forEach(participant => {
              participant.tracks.forEach(publication => {
                if (publication.track) {
                  document.getElementById('remoteTrack').appendChild(publication.track.attach());
                }
              });

              participant.on('trackSubscribed', track => {
                document.getElementById('remoteTrack').appendChild(track.attach());
              });
            });

            //EVENT WHEN PARTICIPANT CONNECTS
            room.on('participantConnected', participant => {
              console.log(`Participant "${participant.identity}" connected`);

              this.$store.state.notification.notification.icon = null;
              this.$store.state.notification.notification.title = null
              setTimeout(() => {
                this.$store.state.notification.notification.icon = 'info';
                this.$store.state.notification.notification.title = participant.identity + ' s-a alaturat conversatiei.';
                let audio = document.getElementById('meeting-joinleave-audio');
                audio.play();
              }, 200)

              participant.tracks.forEach(publication => {
                if (publication.isSubscribed) {
                  const track = publication.track;
                  document.getElementById('remoteTrack').appendChild(track.attach());
                }
              });

              participant.on('trackSubscribed', track => {
                document.getElementById('remoteTrack').appendChild(track.attach());
              });
            });

            room.on('participantDisconnected', participant => {
              this.$store.state.notification.notification.icon = null;
              this.$store.state.notification.notification.title = null
              setTimeout(() => {
                this.$store.state.notification.notification.icon = 'info';
                this.$store.state.notification.notification.title = participant.identity + ' a parasit conversatia.';
                let audio = document.getElementById('meeting-joinleave-audio');
                audio.play();
              }, 200)

              VueThis.$refs.chat.remoteUserDisconnect();
              VueThis.$refs.chat.remoteUserDisconnect();
            });

            room.localParticipant.tracks.forEach(publication => {
              if (publication.kind == 'video') {
                VueThis.localVideoTrack = publication.track;
                let localMediaContainer = document.getElementById('localTrack');
                localMediaContainer.appendChild(publication.track.attach());
              }

              if (publication.kind == 'audio')
                VueThis.localAudioTrack = publication.track;
            });

            room.on('disconnected', room => {
              // Detach the local media elements
              room.localParticipant.tracks.forEach(publication => {
                const attachedElements = publication.track.detach();
                attachedElements.forEach(element => element.remove());
              });
            });

            this.updateLocalUser(); //update localUser in order to send it to the remoteUser

            //display camera preview 1.0.x style
            // if(VueThis.joinWithVideo) {
            //
            //   createLocalVideoTrack().then(track => {
            //     let localMediaContainer = document.getElementById('localTrack');
            //     localMediaContainer.appendChild(track.attach());
            //     VueThis.joinWithVideo = true;
            //   });
            // }

          },error => {

            console.error(`Unable to connect to Room: ${error.message}`);
            // if(joinWithVideo !== false) {
            //   this.$router.push({path: this.$router.currentRoute.path, query: {token: this.$router.currentRoute.query.token, joinVideo: 'false'}});
            //   location.reload();
            // }
            // else{
            //   this.$router.push({path: this.$router.currentRoute.path, query: {token: this.$router.currentRoute.query.token, joinVideo: 'false', joinAudio: 'false'}});
            //   location.reload();
            // }
          });
        },
    },
    mounted() {
        //Hide Tawk.to from this page
        setTimeout(function(){
          let tawkIframe = document.querySelectorAll("iframe[title='chat widget']");
          if(tawkIframe[0] !== undefined){
            tawkIframe[0].parentElement.style.setProperty("display", "none", "important");
          }
        }, 3000)
        //=========RESPONSIVENESS SCRIPTS ACROSS DEVICES==========
        //Screen size / orientation change logic + textarea input expand logic
        var lastTextareaHeight;
        function autoExpandInput(field) {
            let heightLimit = 100;

            // Reset field height
            field.style.height = '25px';

            // Calculate the height
            var height = + field.scrollHeight;

            if(height > heightLimit)
                field.style.height = lastTextareaHeight + 'px';
            else{
                field.style.height = height + 'px';
                lastTextareaHeight = height;
            }
        }
        let sendMsgTextarea = document.getElementById('message-textarea');
        sendMsgTextarea.addEventListener('input', function (event) {
            if(event.target.tagName.toLowerCase() !== 'textarea')
                return;
            autoExpandInput(event.target);
        }, false);

        /* FULLSCREEN TOGGLERS EVENT  */
        window.onload = function() { //IOS OVERFLOW FIX - set inner window height at first load
            var meetingRoomElement = document.getElementsByClassName('meeting-room')[0];
            meetingRoomElement.style.height = window.innerHeight +'px';

        }
        window.onorientationchange = function (){ //required for resizing when going from landscape to portrait and vice-versa
            let meetingRoomElement = document.getElementsByClassName('meeting-room')[0];

            setTimeout(function(){
                meetingRoomElement.style.height = window.innerHeight +'px';

                setTimeout(function(){
                    window.scrollTo(0, 100);
                },'3000')
            },'500');

        }

        //To prevent meetingRoom resizing when keyboard is shown up, use document.activeElement === sendMsgTextarea
        window.onresize = function(){
            if(!(document.activeElement === sendMsgTextarea)){
            var meetingRoomElement = document.getElementsByClassName('meeting-room')[0];
            meetingRoomElement.style.height = window.innerHeight +'px';
            }
        }
        window.onscroll = function(){ //for landscape only [needs double check before added in production]
            if(!(document.activeElement === sendMsgTextarea)) {
                var meetingRoomElement = document.getElementsByClassName('meeting-room')[0];
                meetingRoomElement.style.height = window.innerHeight +'px';
            }
        }
    },
    destroyed(){
     //Hide Tawk.to from this page
      let tawkIframe = document.querySelectorAll("iframe[title='chat widget']");
      if(tawkIframe[0] !== undefined) tawkIframe[0].parentElement.style.display = 'initial';
    }
}
</script>

<style lang="css">

    @keyframes flash {
        0% {opacity: 0;}
        25% {opacity: 1;}
        50% {opacity: 1;}
        75% {opacity: 1;}
        100% {opacity: 0;}
    }

    .flash-new-message{
        position: absolute;
        background-color: red;
        width: 100%;
        height: 100%;
        display: flex;
        opacity: 0%;
        z-index: 5;
        display: none;
    }

    .flash-new-message.flash{
        background-color: #00BCD4;
        animation: flash 5s linear;
        display: flex;
    }

    .flash-new-message > span{
        margin: auto;
        text-align: center;
        font-size: 24px;
        color: white;
        max-width: 80vw;
        text-overflow: ellipsis;
    }

    #localTrack{
        z-index: 5;
        display: flex;
    }

    #localTrack > video{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 32vmin;
        height: 18vmin;
        z-index: 1;
        margin: auto;
    }

    #remoteTrack{
        display: flex;
    }

    #remoteTrack > video{
        position: absolute;
        left: 50%;
        transform: translate(-50%,0);
        height: 100%;
        margin: auto;
    }
</style>

<style lang="scss">
  @import '@/scss/pages/meeting-room';
</style>
